import { CornerUpLeft } from "lucide-react";
import { cn, formatWhatsAppMarkdown } from "@/lib/utils";

export interface WhatsAppTemplatePreviewProps {
  headerText?: string;
  bodyText: string;
  footerText?: string;
  buttons?: string[];
  className?: string;
}

/** Preview estilo bolha WhatsApp para templates (cabeçalho, corpo, rodapé e botões). */
export function WhatsAppTemplatePreviewBubble({
  headerText,
  bodyText,
  footerText,
  buttons,
  className,
}: WhatsAppTemplatePreviewProps) {
  const hasHeader = Boolean(headerText?.trim());
  const hasBody = Boolean(bodyText.trim());
  const hasFooter = Boolean(footerText?.trim());
  const visibleButtons = (buttons ?? []).map((b) => b.trim()).filter(Boolean);
  const hasButtons = visibleButtons.length > 0;
  const hasContent = hasHeader || hasBody || hasFooter || hasButtons;

  if (!hasContent) {
    return (
      <div
        className={cn(
          "rounded-lg bg-[#1f2c34] px-4 py-6 text-center text-sm text-[#8696a0]",
          className,
        )}
      >
        O preview aparecerá aqui
      </div>
    );
  }

  return (
    <div className={cn("overflow-hidden rounded-lg bg-[#1f2c34] text-sm text-[#e9edef] shadow-md", className)}>
      {hasHeader && (
        <p
          className="whitespace-pre-wrap px-3 pt-2.5 font-semibold leading-snug"
          dangerouslySetInnerHTML={{ __html: formatWhatsAppMarkdown(headerText!) }}
        />
      )}

      {hasBody && (
        <p
          className={cn(
            "whitespace-pre-wrap px-3 pb-1",
            hasHeader ? "pt-1" : "pt-2.5",
            !hasFooter && !hasButtons && "pb-2.5",
          )}
          dangerouslySetInnerHTML={{ __html: formatWhatsAppMarkdown(bodyText) }}
        />
      )}

      {hasFooter && (
        <p className={cn("px-3 pb-2.5 text-xs text-[#8696a0]", hasBody || hasHeader ? "pt-0" : "pt-2.5")}>
          {footerText}
        </p>
      )}

      {hasButtons && (
        <div className="border-t border-[#2a3942]">
          {visibleButtons.map((label, idx) => (
            <div
              key={`${label}-${idx}`}
              className={cn(
                "flex items-center justify-center gap-2 px-3 py-2.5 text-center font-medium text-[#53bdeb]",
                idx > 0 && "border-t border-[#2a3942]",
              )}
            >
              <CornerUpLeft className="h-3.5 w-3.5 shrink-0 opacity-80" aria-hidden />
              <span className="truncate">{label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
